module.exports = __webpack_public_path__ + "img/VP-ECONew_Overview-DB_1.30dcfe5a.jpg";